import * as React from 'react';
import {Component, createRef} from 'react';

export interface InjectedElementRefProps {
    elementRef: React.RefObject<any>;
}

export const withElementRef = <P extends object>(
    InnerComponent: React.ComponentType<P & InjectedElementRefProps>
) => {
    return class ElementRef extends Component<P, null> {
        elementRef;

        constructor(props) {
            super(props);

            this.elementRef = createRef();
        }

        render() {
            return <InnerComponent elementRef={this.elementRef} {...this.props} />;
        }
    };
};
